/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ActionDetails {
    getFixupPrototypeFunction() { return ActionDetails.fixupPrototype; }

    static newInstance(model: Partial<ActionDetails>): ActionDetails {
        let obj = Object.assign(new ActionDetails(), model);
        ActionDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ActionDetails>): ActionDetails {
        if (!model) return null;
        return ActionDetails.newInstance(<ActionDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ActionDetails) {
        if (!obj) return;

        models.ActionDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ActionDetails): boolean {
        Object.setPrototypeOf(obj, ActionDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the action
     */
    name: string;

    /**
     * Terms and Conditions of the action
     */
    terms_and_conditions: string;

    /**
     * Pre execute is required or not
     */
    preexecute_required: string;

    /**
     * Action Type
     */
    action_type: string;

    /**
     * Action Resource Name
     */
    action_resource_name: string;

    /**
     * Description of the action
     */
    description: string;

}
